<template>
  <div class="left_nav">
    <div class="left_nav_items">
      <b-nav>
        <b-nav-item class="ace_sec_txt" @click="navigateToIntroduction" :active="active === 'introduction'" aria-label="Introduction">
          Introduction
        </b-nav-item>
        <b-nav-item class="ace_sec_txt" v-if="showCareerDetailTab" @click="navigateToCareerDetail" :active="active === 'detail'" :aria-label="careerDetailTabLabel">
          {{careerDetailTabLabel}}
        </b-nav-item>
        <b-nav-item class="ace_sec_txt" id="careerProgramsTour" v-if="showProgramsTab" @click="navigateToPrograms" :active="active === 'programs'" :aria-label="programsTabLabel">
          {{programsTabLabel}}
        </b-nav-item>
        <b-nav-item class="ace_sec_txt" id="relatedCareersTour" v-if="showRelatedCareersTab" @click="navigateToRelatedCareers" :active="active === 'related'" :aria-label="relatedCareersLabel">
          {{relatedCareersLabel}}
        </b-nav-item>
        <b-nav-item class="ace_sec_txt" v-if="((isEMSIFeatureEnabled || isBGTFeatureEnabled) && showJobPostingsTab)" @click="navigateToJobs" :active="active === 'jobs'" :aria-label="jobPostingsTabLabel">
          {{jobPostingsTabLabel}}
        </b-nav-item>
        <b-nav-item class="ace_sec_txt" v-if="showStreamsTab" @click="navigateToViewStreams" :active="active === 'streams'" :aria-label="streamsTabLabel">
          {{streamsTabLabel}}
        </b-nav-item>
        <b-nav-item class="ace_sec_txt" v-if="showAlumniInsightsTab" @click="navigateToInsights" :active="active === 'insights'" :aria-label="alumniInsightsTabLabel">
          {{alumniInsightsTabLabel}}
        </b-nav-item>
        <!--
        <b-nav-item class="ace_sec_txt" @click="navigateToCocurricular" :active="active === 'cocurricular'" aria-label="Co-Curricular">
          Co-Curricular
        </b-nav-item>
        -->
      </b-nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'careerNavigation',
  props: ['code', 'cipCode', 'returnTo', 'active'],
  components: {
  },
  data: () => {
    return {
      DEFAULT_RETURN_TO: 'exploreCareerResults'
    }
  },

  mounted () {
    this.$parent.showBackToResultButton = (this.$route.query.returnTo !== 'programGuideCareers')
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity'
    ]),
    navigateToIntroduction () {
      this.loadLogDashboardActivity({action: 'clickCareerIntroductioView', page: 'career ' + this.active, link: 'Career Introduction'})
      return this.$router.push({ name: 'careerDetail', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToCareerDetail () {
      this.loadLogDashboardActivity({action: 'clickCareerDetailView', page: 'career ' + this.active, link: 'Career Prospects'})
      return this.$router.push({ name: 'careerDetailProspects', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToPrograms () {
      this.loadLogDashboardActivity({action: 'clickCareerProgramsView', page: 'career ' + this.active, link: 'Career Programs'})
      return this.$router.push({ name: 'careerPrograms', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToRelatedCareers () {
      this.loadLogDashboardActivity({action: 'clickRelatedCareersView', page: 'career ' + this.active, link: 'Related Careers'})
      return this.$router.push({ name: 'relatedCareers', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToViewStreams () {
      this.loadLogDashboardActivity({action: 'clickCareerStreamsView', page: 'career ' + this.active, link: 'Career Streams'})
      return this.$router.push({ name: 'careerStreams', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToInsights () {
      this.loadLogDashboardActivity({action: 'clickCareerInsightsView', page: 'career ' + this.active, link: 'Career Insights'})
      return this.$router.push({ name: 'careerInsights', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToCocurricular () {
      this.loadLogDashboardActivity({action: 'clickCareerCocurricularView', page: 'career ' + this.active, link: 'Career Co-Curricular'})
      return this.$router.push({ name: 'careerCocurricular', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    navigateToJobs () {
      this.loadLogDashboardActivity({action: 'clickCareerJobsView', page: 'career ' + this.active, link: 'Career Jobs'})
      return this.$router.push({ name: 'careerJobs', params: this.careerRouterParams, query: this.careerQueryParam })
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },

  computed: {
    ...mapState({
      'enabledFeatures': state => state.institution.enabledFeatures,
      'packages': state => state.institution.packages,
      'career': state => state.career.careerObject
    }),
    exploreCareerDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showCareerDetailTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.introductionTab) {
        return false
      }
      return exploreCareerDetailFlagMap.introductionTab.enabled
    },
    careerDetailTabLabel () {
      const defaultLabel = 'Career Prospects'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.introductionTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.introductionTab.label || defaultLabel
    },
    showRelatedCareersTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.relatedCareersTab) {
        return false
      }
      return exploreCareerDetailFlagMap.relatedCareersTab.enabled
    },
    relatedCareersLabel () {
      const defaultLabel = 'Related Careers'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.relatedCareersTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.relatedCareersTab.label || defaultLabel
    },
    showProgramsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.programsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.programsTab.enabled
    },
    programsTabLabel () {
      const defaultLabel = 'Programs'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.programsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.programsTab.label || defaultLabel
    },
    showStreamsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.streamsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.streamsTab.enabled
    },
    streamsTabLabel () {
      const defaultLabel = 'Pathways'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.streamsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.streamsTab.label || defaultLabel
    },
    showAlumniInsightsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.alumniInsightsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.alumniInsightsTab.enabled
    },
    alumniInsightsTabLabel () {
      const defaultLabel = 'Alumni Insights'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.alumniInsightsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.alumniInsightsTab.label || defaultLabel
    },
    showJobPostingsTab () {
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerJobPostingsTab) {
        return false
      }
      return exploreCareerDetailFlagMap.careerJobPostingsTab.enabled
    },
    jobPostingsTabLabel () {
      const defaultLabel = 'Job Postings'
      let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
      if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerJobPostingsTab) {
        return defaultLabel
      }
      return exploreCareerDetailFlagMap.careerJobPostingsTab.label || defaultLabel
    },
    isEMSIFeatureEnabled () {
      let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
      return emsiFeature && emsiFeature.enabled
    },
    isBGTFeatureEnabled () {
      let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
      return bgtFeature && bgtFeature.enabled
    },
    careerRouterParams () {
      let routerParams = {
        code: this.code || this.career.pragyaSoc,
        cipCode: this.cipCode,
        returnTo: this.returnTo || this.DEFAULT_RETURN_TO,
        showBackToResultButton: true
      }
      return routerParams
    },
    careerQueryParam () {
      let queryParam = {
        returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
      }
      return queryParam
    }
  }
}
</script>
<style>
.stream-left-panel {
	.stream-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerNavigation.vue